import { Field, Textarea } from "../../../core/components/ui/input";
import { TermsMarkdown } from "./terms-markdown";

interface TermsEditorProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  hint?: string;
  disabled?: boolean;
}

/** Source markdown à gauche, aperçu à droite (empilés sur petit écran). */
export function TermsEditor({
  value,
  onChange,
  label = "Termes (markdown)",
  hint,
  disabled,
}: TermsEditorProps) {
  return (
    <div className="garantie-form__split">
      <Field label={label} hint={hint}>
        <Textarea
          className="garantie-form__source"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          spellCheck
        />
      </Field>
      <div className="garantie-form__preview">
        <span className="garantie-form__preview-label">Aperçu</span>
        <div className="garantie-form__preview-body">
          <TermsMarkdown body={value} />
        </div>
      </div>
    </div>
  );
}
